import {
  CardPreview,
  CardPreviewProps,
  Section,
  SectionHeading,
} from "@/components";
import { ColorKeys } from "@/theme/colors";
import "./Insights.scss";

type Props = {
  title: string;
  items: CardPreviewProps[];
  colorTitle?: ColorKeys;
  showBackgroundRectangle?: boolean;
};

export const Insights = ({
  title,
  items = [],
  colorTitle = "slate-20",
  showBackgroundRectangle = true,
}: Props) => {
  return (
    <Section className="ui-insights-section">
      {showBackgroundRectangle && (
        <div className="ui-insights-background-rectangle"></div>
      )}
      <SectionHeading
        className="ui-insights-items-section-title"
        title={title}
        color={colorTitle}
        titleMarginBottom=""
        fs="3"
        mdFs="3"
      />
      <ul
        role="list"
        aria-label={`Lista di ${title}`}
        className={`list-style-none ui-insights-items-layout ${!title ? "mt-x56" : ""}`}
      >
        {items?.map((item, index) => {
          return (
            <li key={index}>
              <CardPreview {...item} />
            </li>
          );
        })}
      </ul>
    </Section>
  );
};
